import { ref, Ref } from 'vue';
import { ImgErrorComposableType } from './img-error-composable';

export function imgErrorComposable(): ImgErrorComposableType {
  const imgError: Ref<boolean> = ref(false);

  const imgNotLoading = (error = false) => {
    if (error) console.error(`${error}: Map Not Loading`);
    imgError.value = true;
  }

  return {
    imgError,
    imgNotLoading
  }
};
